import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';

import { LoadingSpinner } from '@/components/LoadingSpinner';
import { Box } from '@/components/lib/components';
import { ds } from '@/components/lib/design.system';
import { PaymentMethodTypes } from '@/feature/deposit/const';
import { DepositErrorResponse } from '@/feature/deposit/hooks/use-deposit';
import { useDepositStatusStore } from '@/feature/deposit/hooks/use-deposit-status-store';
import { useFundFantasyFromSocialWallet } from '@/feature/deposit/hooks/use-fund-fantasy-from-social-wallet';
import { usePreventAndroidBackNavigation } from '@/hooks/use-prevent-android-back-navigation';
import { DepositStackParamList } from '@/navigation/types';
import { getWalletErrorCode } from '@/utils/get-wallet-error-code';
import { toLocaleCurrency } from '@/utils/numeric/currency';

export const SocialWalletDepositScreen = () => {
    const navigation = useNavigation<NativeStackNavigationProp<DepositStackParamList>>();
    const { t } = useTranslation('wallet');
    const selectedAmount = useDepositStatusStore(state => state.selectedAmount);
    const amount = Number(selectedAmount);
    const { mutate: fundFantasyFromSocialWallet } = useFundFantasyFromSocialWallet();

    usePreventAndroidBackNavigation();

    useEffect(() => {
        fundFantasyFromSocialWallet(amount, {
            onSuccess: () => {
                navigation.navigate('SuccessfulDepositModal', {
                    paymentProvider: PaymentMethodTypes.SocialWallet,
                    title: t('social_wallet_funding_success_title'),
                    description: t('social_wallet_funding_success_description', {
                        amount: toLocaleCurrency(amount),
                    }),
                });
            },
            onError: error => {
                navigation.navigate('FailedDepositModal', {
                    paymentProvider: PaymentMethodTypes.SocialWallet,
                    errorCode: getWalletErrorCode(error as DepositErrorResponse),
                });
            },
        });
    }, [amount, fundFantasyFromSocialWallet, navigation, t]);

    return (
        <Box
            flex={1}
            justifyContent="center"
            alignItems="center"
            backgroundColor={ds.colorToken.background.neutral.base}
        >
            <LoadingSpinner />
        </Box>
    );
};
